<template>
  <modal
    :loading="loading"
    :title="$t('myboxes.relabel_jobs.title')"
    style="max-width: 640px"
    @close_modal="close_modal"
  >
    <template v-slot:content>
      <p v-if="!loading && jobs.length === 0" class="text-body-2 mb-0">
        {{ $t('myboxes.relabel_jobs.empty') }}
      </p>

      <template v-else>
        <p class="text-caption text-medium-emphasis mb-4">
          {{ summaryText }}
        </p>

        <section v-if="runningJobs.length > 0" class="mb-4">
          <div class="text-overline mb-2">{{ $t('myboxes.relabel_jobs.running') }}</div>
          <relabel-in-filter-job-row
            v-for="job in visibleRunningJobs"
            :key="'running-' + job.id"
            :job="job"
            :filter-options="filterOptions"
            @cancelled="refresh"
          />
          <p v-if="hiddenRunningCount > 0" class="text-caption text-medium-emphasis mb-0 mt-2">
            {{ $t('myboxes.relabel_jobs.and_more_running', { count: hiddenRunningCount }) }}
          </p>
        </section>

        <section v-if="queuedJobs.length > 0">
          <div class="text-overline mb-2">{{ $t('myboxes.relabel_jobs.queued') }}</div>
          <relabel-in-filter-job-row
            v-for="job in visibleQueuedJobs"
            :key="'queued-' + job.id"
            :job="job"
            :filter-options="filterOptions"
            queued
            @cancelled="refresh"
          />
          <p v-if="hiddenQueuedCount > 0" class="text-caption text-medium-emphasis mb-0 mt-2">
            {{ $t('myboxes.relabel_jobs.and_more_queued', { count: hiddenQueuedCount }) }}
          </p>
        </section>
      </template>
    </template>

    <template v-slot:buttons>
      <v-btn small text color="primary" @click="refresh">
        <v-icon small class="mr-1">fas fa-sync-alt</v-icon>
        {{ $t('auto_t.btn_refresh') }}
      </v-btn>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/Modal';
import RelabelInFilterJobRow from '@/components/myboxes/RelabelInFilterJobRow.vue';
import {
  RELABEL_JOB_DISPLAY_LIMIT,
  isQueuedJob,
  isRunningJob,
} from '@/components/myboxes/relabelInFilterJobUtils';

export default {
  name: 'RelabelInFilterJobsModal',
  components: { Modal, RelabelInFilterJobRow },
  data() {
    return {
      manualRefreshLoading: false,
      filterOptions: [],
    };
  },
  computed: {
    jobs() {
      return this.$store.getters['project_live_jobs/relabel_jobs'];
    },
    loading() {
      return this.manualRefreshLoading;
    },
    runningJobs() {
      return this.jobs.filter(isRunningJob);
    },
    queuedJobs() {
      return this.jobs.filter(isQueuedJob);
    },
    visibleRunningJobs() {
      return this.runningJobs.slice(0, RELABEL_JOB_DISPLAY_LIMIT);
    },
    visibleQueuedJobs() {
      return this.queuedJobs.slice(0, RELABEL_JOB_DISPLAY_LIMIT);
    },
    hiddenRunningCount() {
      return Math.max(0, this.runningJobs.length - RELABEL_JOB_DISPLAY_LIMIT);
    },
    hiddenQueuedCount() {
      return Math.max(0, this.queuedJobs.length - RELABEL_JOB_DISPLAY_LIMIT);
    },
    summaryText() {
      return this.$t('myboxes.relabel_jobs.summary', {
        running: this.runningJobs.length,
        queued: this.queuedJobs.length,
      });
    },
  },
  async mounted() {
    await this.loadFilterOptions();
    await this.$store.dispatch('project_live_jobs/ensure_subscribed');
  },
  methods: {
    close_modal() {
      this.$emit('close_modal');
    },
    async loadFilterOptions() {
      try {
        this.filterOptions = await this.$api.asset.filter_options();
      } catch (error) {
        console.error('Failed to load filter options', error);
        this.filterOptions = [];
      }
    },
    async refresh() {
      this.manualRefreshLoading = true;
      try {
        await this.$store.dispatch('project_live_jobs/fetch_active');
      } catch (error) {
        console.error('Failed to load relabel jobs', error);
      } finally {
        this.manualRefreshLoading = false;
        this.$emit('updated');
      }
    },
  },
};
</script>
